webpackJsonp([275215463505218],{

/***/ 1542:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ReconciliationNoteInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"cashBank","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"cashDeposited","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"defaultValue":null,"description":null,"name":"date","type":{"kind":"SCALAR","name":"Date","ofType":null}},{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"notes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"undone","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-reconciliation-note-input-c1feb7dadb400e59e861.js